// Helper to derive operator-type tags from a contact record returned by
// the API. The truth source is the user's membership in the `permissions`
// table (NOT their participations in entities like quotes/orders).
//
// The backend (`contacts.service.ts::findAll`) enriches each row with:
//   contact.permissions = { store: [...], seller: [...] }
// where each array holds the user's active memberships of that type.
//
// Rules:
//   - Store Operator  → `permissions.store.length > 0`
//   - Seller Operator → `permissions.seller.length > 0`
//   - Both            → both flags true
//   - Neither         → pure Customer (no tags)

type ContactLike = {
  permissions?: {
    store?: unknown[];
    seller?: unknown[];
  } | null;
} & Record<string, unknown>;

export type OperatorTagFlags = {
  isStoreOperator: boolean;
  isSellerOperator: boolean;
};

export const getOperatorTags = (
  contact: ContactLike | null | undefined,
): OperatorTagFlags => {
  const storeMemberships = contact?.permissions?.store;
  const sellerMemberships = contact?.permissions?.seller;
  return {
    isStoreOperator: Array.isArray(storeMemberships) && storeMemberships.length > 0,
    isSellerOperator:
      Array.isArray(sellerMemberships) && sellerMemberships.length > 0,
  };
};
